import useGetExaminationDetails, {
  QuestionFieldType,
  QuestionType,
  QmsskuType,
} from './useGetExaminationDetails';

export default useGetExaminationDetails;
export { QuestionFieldType, QmsskuType };
export type { QuestionType };
